import { omitBy, isEmpty } from 'lodash';
import qs from 'qs';

import { getQueryParam } from 'helpers/queryParam';
import { makeSelectRelativeMenuWeek } from 'selectors/dashboard';
import { selectFilterContext } from 'reducers/mealFilters';

export const UPDATE_MEAL_FILTER = 'UPDATE_MEAL_FILTER';
export const UPDATE_MEAL_FILTER_V3 = 'UPDATE_MEAL_FILTER_V3';
export const DASHBOARD_CLEAR_ALL_FILTERS = 'DASHBOARD_CLEAR_ALL_FILTERS';
export const CLEAR_MEAL_FILTER = 'CLEAR_MEAL_FILTER';
export const SET_FILTER_CONTEXT = 'SET_FILTER_CONTEXT';

export const updateMealFilter = ({
  filter,
  value,
  stageStep,
  menuSlug,
  relativeMenuWeek,
  isQuickFilter,
}) => ({
  type: UPDATE_MEAL_FILTER,
  filter,
  value,
  stageStep,
  menuSlug,
  relativeMenuWeek,
  isQuickFilter,
});

export const updateV3MealFilter = ({
  filter,
  value,
  stageStep,
  menuSlug,
  relativeMenuWeek,
  isQuickFilter,
}) => ({
  type: UPDATE_MEAL_FILTER_V3,
  filter,
  value,
  stageStep,
  menuSlug,
  relativeMenuWeek,
  isQuickFilter,
});

export const clearMealFilter = filter => ({
  type: CLEAR_MEAL_FILTER,
  filter,
});

export const clearAllFilters = ({ shouldLog = false } = {}) => ({
  type: DASHBOARD_CLEAR_ALL_FILTERS,
  shouldLog,
});

export const setFilterContext = ({ menuSlug, stageStep }) => ({
  type: SET_FILTER_CONTEXT,
  menuSlug,
  stageStep,
});

export const updateMealFilterAndUrl =
  ({ filter, value, isQuickFilter }) =>
  async (dispatch, getState) => {
    if (isQuickFilter) {
      await dispatch(clearAllFilters());
      clearAllUrlFilters();
    }
    const state = getState();
    const { menuSlug, stageStep } = selectFilterContext(state) || {};
    const relativeMenuWeek = makeSelectRelativeMenuWeek()(state, menuSlug);
    await dispatch(
      updateMealFilter({ filter, value, stageStep, menuSlug, relativeMenuWeek, isQuickFilter })
    );
    updateUrlWithFilters({ filter, value });
  };

export const updateV3MealFilterAndUrl =
  ({ filter, value, isQuickFilter }, stageStep) =>
  async (dispatch, getState) => {
    if (isQuickFilter) {
      await dispatch(clearAllFilters());
      clearAllUrlFilters();
    }
    const state = getState();
    const { menuSlug } = selectFilterContext(state) || {};
    const relativeMenuWeek = makeSelectRelativeMenuWeek()(state, menuSlug);
    await dispatch(
      updateV3MealFilter({
        filter,
        value,
        stageStep,
        menuSlug,
        relativeMenuWeek,
        isQuickFilter,
      })
    );
    updateUrlWithFilters({ filter, value });
  };

export const clearMealFilterAndUrl = filter => async dispatch => {
  await dispatch(clearMealFilter(filter));
  updateUrlWithFilters({ filter });
};

export const clearAllFiltersAndUrl = () => async dispatch => {
  await dispatch(clearAllFilters());
  clearAllUrlFilters();
};

const updateUrlFilter = ({ filter, stringifiedFilters }) => {
  let filters = getQueryParam(window.location, 'filter') || {};
  filters[filter] = stringifiedFilters;

  return qs.stringify({ filter: omitBy(filters, isEmpty) }, { addQueryPrefix: true });
};

const clearAllUrlFilters = () => {
  window.history.replaceState({ path: '' }, '', window.location.pathname);
};

const updateUrlWithFilters = ({ filter, value = {} }) => {
  const stringifiedFilters = Object.keys(value).toString();
  const updatedPath = updateUrlFilter({ filter, stringifiedFilters });

  window.history.replaceState({ path: updatedPath }, '', updatedPath || window.location.pathname);
};
